import { colors } from '../../styles/colors';
import { formatEuro } from '../../utils/formatters';

/**
 * FactureTotaux - Section des totaux d'une facture
 *
 * Affiche le taux de TVA sélectionnable et les totaux calculés (HT, TVA, TTC).
 *
 * @param {Object} props
 * @param {number} props.tauxTVA - Taux de TVA (décimal, ex: 0.2 pour 20%)
 * @param {Function} props.onTauxTVAChange - Handler pour changer le taux
 * @param {Object} props.totals - { montantHT, tva, montantTTC }
 * @param {boolean} props.readOnly - Mode lecture seule
 */
export default function FactureTotaux({ tauxTVA, onTauxTVAChange, totals, readOnly }) {
  const rowStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  };

  return (
    <div style={{
      marginTop: '2rem',
      padding: '1.5rem',
      backgroundColor: '#f9fafb',
      borderRadius: '0.5rem',
      border: `1px solid ${colors.secondary.lightGray}`
    }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        {/* Taux TVA */}
        <div style={rowStyle}>
          <label style={{ fontSize: '0.875rem', fontWeight: '600', color: colors.primary.gray }}>
            Taux TVA :
          </label>
          <select
            value={tauxTVA}
            onChange={(e) => onTauxTVAChange(parseFloat(e.target.value))}
            disabled={readOnly}
            style={{
              padding: '0.5rem',
              border: `1px solid ${colors.secondary.lightGray}`,
              borderRadius: '0.25rem',
              fontSize: '0.875rem',
              backgroundColor: readOnly ? colors.secondary.lightGray : colors.text.white,
              cursor: readOnly ? 'not-allowed' : 'pointer',
              opacity: readOnly ? 0.6 : 1
            }}
          >
            <option value={0}>0% (exonéré)</option>
            <option value={0.055}>5,5% (réduit)</option>
            <option value={0.1}>10% (intermédiaire)</option>
            <option value={0.2}>20% (normal)</option>
          </select>
        </div>

        <div style={{ height: '1px', backgroundColor: colors.secondary.lightGray, margin: '0.5rem 0' }} />

        {/* Montant HT */}
        <div style={rowStyle}>
          <span style={{ fontSize: '0.875rem', fontWeight: '600', color: colors.primary.gray }}>
            Montant HT :
          </span>
          <span style={{ fontSize: '1rem', fontWeight: '700', color: colors.primary.gray }}>
            {formatEuro(totals.montantHT)}
          </span>
        </div>

        {/* TVA */}
        <div style={rowStyle}>
          <span style={{ fontSize: '0.875rem', color: colors.secondary.mediumGray }}>
            TVA ({(tauxTVA * 100).toLocaleString('fr-FR')}%) :
          </span>
          <span style={{ fontSize: '0.875rem', color: colors.secondary.mediumGray }}>
            {formatEuro(totals.tva)}
          </span>
        </div>

        {/* Montant TTC */}
        <div style={{
          ...rowStyle,
          paddingTop: '0.5rem',
          borderTop: `2px solid ${colors.secondary.lightGray}`
        }}>
          <span style={{ fontSize: '1rem', fontWeight: '700', color: colors.primary.gray }}>
            Montant TTC :
          </span>
          <span style={{ fontSize: '1.25rem', fontWeight: '700', color: colors.primary.teal }}>
            {formatEuro(totals.montantTTC)}
          </span>
        </div>
      </div>
    </div>
  );
}
